module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hans/5/3-e246a41304afd3d8ac8025d1853666c9.jpg";